import { useRef, useEffect, useState } from 'react';
import PopupRef from '../component/PopupRef';

const TelNoInputBox = ({
    title,
    value,
    placeholder = null,
    size,
    autoComplete,
    onKeyDown = () => {},
    setTelNo,
    disabled = false,
    maxLength,
    focus = false,
}) => {
    const popupRef = useRef(null);
    const inputFocus = useRef(null);
    const [localTelNo, setLocalTelNo] = useState('');
    const [inputValue, setInputValue] = useState(value || '');

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    useEffect(() => {
        // if ((inputValue && inputValue.length === 13) || (inputValue && inputValue.length === 11)) {
        //     setInputValue(inputValue.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'));
        // }

        if (inputValue && inputValue.startsWith('02', 0) && (inputValue.length === 9 || inputValue.length === 11)) {
            setInputValue(inputValue.replace(/-/g, '').replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'));
        } else if (
            inputValue &&
            inputValue.startsWith('02', 0) &&
            (inputValue.length === 10 || inputValue.length === 12)
        ) {
            setInputValue(inputValue.replace(/-/g, '').replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3'));
        } else if (inputValue && (inputValue.length === 10 || inputValue.length === 12)) {
            setInputValue(inputValue.replace(/-/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
        } else if (inputValue && (inputValue.length === 11 || inputValue.length === 13)) {
            setInputValue(inputValue.replace(/-/g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'));
        }
    }, [inputValue]);

    const onChange = (e) => {
        const regex = /^[0-9\b -]{0,13}$/;
        const val = e.target.value;
        if (regex.test(val)) {
            setInputValue(val);
            setTelNo(val.replaceAll('-', ''));
            setLocalTelNo(val.replaceAll('-', ''));
        }
    };

    return (
        <div
            className={
                'form-box' +
                (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
            }
        >
            <div className='input-box'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <input
                        id={title}
                        type='text'
                        ref={inputFocus}
                        className='form-control'
                        disabled={disabled}
                        value={inputValue}
                        placeholder={placeholder}
                        onChange={(e) => onChange(e)}
                        onKeyDown={(e) => onKeyDown(e)}
                        autoComplete={autoComplete ? 'on' : 'off'}
                        maxLength={maxLength && maxLength}
                        onBlur={(e) => {
                            if (focus && localTelNo.length < 11) {
                                popupRef.current.openAlert('전화번호를 확인해주세요.', () => {
                                    return function () {
                                        inputFocus.current.focus();
                                    };
                                });
                            }
                        }}
                    />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </div>
    );
};

export default TelNoInputBox;
